<template>
  <!-- Floating Cart Button -->
  <button 
    class="bg-rose-600 rounded-full text-white w-12 h-12 grid place-content-center shadow-lg fixed z-30 bottom-4 start-4"
    :class="{ 'animate__animated animate__heartBeat': isAnimating }"
    @click="toggleCart"
  >
    <FlowerIcon name="cart" class="size-8" />
    <div v-if="totalQuantity" class="absolute bg-white shadow-lg text-black w-6 h-6 rounded-full -right-1 -top-2">
      {{ totalQuantity }}
    </div>
  </button>
    
  <!-- Cart Panel -->
  <div
   v-if="isCartOpen"
   class="w-56 bg-white p-4 rounded-md shadow-lg fixed z-30 left-4 bottom-20"
   :class="[animationClass]"
   >
      <div v-if="!totalQuantity">Your cart is empty</div>
      <div v-else>
        <ul>
          <li v-for="item in cartStore.items" :key="item.id" class="flex">
            {{ item.name }} - {{ item.quantity }}
            <button @click="cartStore.removeFromCart(item.id)" class="ms-auto">
              <FlowerIcon name="trash" class="size-4" />
            </button>
          </li>
        </ul>
      </div>
  </div>

  <!-- Backdrop -->
  <div
    v-if="isCartOpen"
    class="fixed inset-0 z-20"
    @click="closeBackdrop"
  ></div>

</template>

<script>
import { useCartStore } from "@/stores/cart";
import FlowerIcon from "./FlowerIcon.vue";

export default {
  components: {
    FlowerIcon,
  },
  data() {
    return {
      isCartOpen: false,
      isAnimating: false,
      cartStore: useCartStore(),
      animationClass: '',
    };
  },
  created() {
    this.cartStore.loadFromLocalStorage();
  },
  computed: {
    totalQuantity() {
      return this.cartStore.items.reduce((sum, item) => sum + item.quantity, 0);
    }
  },
  methods: {
    toggleCart() {
      if (!this.isCartOpen) {
        this.isCartOpen = true;
        this.animationClass = 'animate__animated animate__fadeInUp';
      } else {
        this.animationClass = 'animate__animated animate__fadeOutDown';
        setTimeout(() => {
          this.isCartOpen = false;
        }, 500);
      }
    },
    closeBackdrop() {
      this.animationClass = 'animate__animated animate__fadeOutDown';
        setTimeout(() => {
          this.isCartOpen = false;
        }, 500);
    }
  },
  watch: {
    totalQuantity() {
      this.isAnimating = true;
      setTimeout(() => {
        this.isAnimating = false;
      }, 400);
    },
  }
};
</script>
